// controllers/focus_input_controller.js
import { Controller } from "@hotwired/stimulus";

export default class SlashFocus extends Controller<HTMLInputElement> {
	static targets = ["input"];

	connect() {
		document.addEventListener("keydown", this.handleKeydown);
	}

	disconnect() {
		document.removeEventListener("keydown", this.handleKeydown);
	}

	handleKeydown = (event: KeyboardEvent) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		if (event.key === "/" && !this.isTyping(event.target as HTMLElement)) {
			event.preventDefault();
			this.element.focus();
		}
	};

	isTyping(element: HTMLElement) {
		return element.matches("input, textarea, select") || element.isContentEditable;
	}
}
